import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Typography, IconButton, Icon, Badge } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';
import { connect } from 'react-redux';

import { getCurrentOrder } from '../../../selectors';
import { getCurrencySymbol, getOrderPrice } from '../../../services/functions/Functions';
import '../../../css/core/components/ShoppingCart.scss';

class ShoppingCart extends React.Component {
  handleClick = () => {
    const {
      onHandleClick, user, onHandleOpenCheckoutDrawer,
    } = this.props;
    if (!user) {
      const updateCoreViewState = {
        cartIconWasPressed: true,
      };
      onHandleClick(null, updateCoreViewState);
      return;
    }
    onHandleOpenCheckoutDrawer();
  }

  renderCheckoutIcon = (props) => {
    const {
      itemsQuantity,
    } = props;

    return (
      <Badge badgeContent={itemsQuantity} color="secondary" >
        <Icon className="shoppingCart-checkoutIcon">shopping_cart</Icon>
      </Badge>
    );
  }

  renderCheckoutText = (props) => {
    const {
      orderPrice,
    } = props;

    return (
      <div className="shoppingCart-checkoutContainer">
        <Typography variant="h5" className="shoppingCart-checkoutText">
          {`${getCurrencySymbol()}${orderPrice.toFixed(2)}`}
        </Typography>
      </div>
    );
  }

  render() {
    const {
      currentOrder,
    } = this.props;

    const orderPrice = getOrderPrice(currentOrder);
    let itemsQuantity = 0;

    if (currentOrder) {
      itemsQuantity = currentOrder.items ? currentOrder.items.length : 0;
    }

    const checkoutLabelProps = {
      itemsQuantity,
      orderPrice,
    };

    return (
      <div id="headerCart" className="shoppingCart-shoppingCartContainer">
        <IconButton
          className="shoppingCart-redirectLink"
          onClick={this.handleClick}
        >
          <div className="shoppingCart-shoppingCartLabel">
            { this.renderCheckoutIcon(checkoutLabelProps) }
            { this.renderCheckoutText(checkoutLabelProps) }
          </div>
        </IconButton>
      </div>
    );
  }
}

ShoppingCart.propTypes = {
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  onHandleClick: PropTypes.func.isRequired,
  currentOrder: PropTypes.objectOf(PropTypes.any),
  user: PropTypes.objectOf(PropTypes.any),
  onHandleOpenCheckoutDrawer: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  currentOrder: getCurrentOrder(state),
});

ShoppingCart.defaultProps = {
  currentOrder: {},
  user: null,
};

export default connect(mapStateToProps)((withRouter(withWidth()(ShoppingCart))));
